import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"

function Pricing() {
  return (
    <Layout>
      <SEO title="Page two" />
      <h1>Hi from the second page</h1>
      <p>Welcome to page Pricing</p>
      <Link to="/">Go back to the homepage</Link>
    </Layout>
  )
}

export default Pricing
